import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
Vue.use(VueAxios,axios);


const getDefaultOrderState = () => {
    return {
        order_detail:[]
    }
  }

  // initial state
const state = getDefaultOrderState()

/*
const state = {
    order_detail:[]
}*/

const getters = {
    allOrderDetail: state => state.order_detail,
}

const actions = {
    async getOrderDetails({ commit }) {

        let userinfolocal = JSON.parse(localStorage.getItem('userinfo'))
        let order_detail = 
                {
                    "store_id":userinfolocal.store_id,
                    "phone":userinfolocal.phone
                }

              //  console.log("order_detail "+JSON.stringify(userinfolocal))
        const response = await axios.post("orderbycust",order_detail)
       
        commit("setOrderDetail", response.data.data);
    },
    async resetOrderState ({ commit }) {
        commit('resetOrderState')
    },
}

const mutations = {
    setOrderDetail: (state,order_details) => {
        state
          //  console.log("order_details are "+JSON.stringify(order_details))


            order_details.find(order => {

                   let id = order.id
                   let order_id = order.order_id
                   let store_id = order.store_id
                   let cust_name = order.cust_name
                   let phone = order.phone
                   let email = order.email
                   let line_1 = order.line_1
                   let line_2 = order.line_2
                   let order_level_discount = order.order_level_discount
                   let delivery_type = order.delivery_type
                   let instructions = order.instructions
                   let quantity = order.quantity
                   let order_level_total_charges = order.order_level_total_charges
                   let order_level_total_taxes = order.order_level_total_taxes
                   let order_state = order.order_state
                   let order_subtotal = order.order_subtotal
                   let order_total = order.order_total
                   let orderDateTime = order.orderDateTime
                   let sync_time = order.sync_time
                   let billing_type = order.billing_type
                   let is_offline_order = order.is_offline_order
                   let delivery_boy_name = order.delivery_boy_name
                   let delivery_boy_phone = order.delivery_boy_phone
                   let reason = order.reason
                   let table_no = order.table_no
                   let room_no = order.room_no
                   let paygateway_orderid = order.paygateway_orderid
                   let order_cancelled_by = order.order_cancelled_by
                   let digi_order_type = order.digi_order_type
                   let order_later_datetime = order.order_later_datetime
                   let coupan_code = order.coupan_code
                   let coupan_value = order.coupan_value
                   let coupan_calculated_amt = order.coupan_calculated_amt
                   let coupan_type = order.coupan_type
                   let delivery_boy_state = order.delivery_boy_state
                   let dunzo_task_id = order.dunzo_task_id
                   let dunzo_task_json = order.dunzo_task_json
                   let dunzo_request_id = order.dunzo_request_id
                   let cust_lat = order.cust_lat
                   let cust_lng = order.cust_lng
                   let type_of_order = order.type_of_order
                   let charges_level_total_tax = order.charges_level_total_tax


                let order_detail_main = {
                    id,
                    order_id,
                    store_id,
                    cust_name,
                    phone,
                    email,
                    line_1,
                    line_2,
                    order_level_discount,
                    delivery_type,
                    instructions,
                    quantity,
                    order_level_total_charges,
                    order_level_total_taxes,
                    order_state,
                    order_subtotal,
                    order_total,
                    orderDateTime,
                    sync_time,
                    billing_type,
                    is_offline_order,
                    delivery_boy_name,
                    delivery_boy_phone,
                    reason,
                    table_no,
                    room_no,
                    paygateway_orderid,
                    order_cancelled_by,
                    digi_order_type,
                    order_later_datetime,
                    coupan_code,
                    coupan_value,
                    coupan_calculated_amt,
                    coupan_type,
                    delivery_boy_state,
                    dunzo_task_id,
                    dunzo_task_json,
                    dunzo_request_id,
                    cust_lat,
                    cust_lng,
                    type_of_order,
                    charges_level_total_tax,
                    }


               console.log("order_detail_main "+JSON.stringify(order_detail_main))

             //  let add_charge = []

                    order_details.find(charges => {
                        console.log("Charges is "+ JSON.stringify(charges.tmpos_order_charges))
                    })
                    

               let ordered_menu = {}


               console.log("ordered_menu "+JSON.stringify(ordered_menu))
            })



    },
    resetOrderState (state) {
        // Merge rather than replace so we don't lose observers
        // https://github.com/vuejs/vuex/issues/1118
        Object.assign(state, getDefaultOrderState())
    }
}


export default {
    state,
    getters,
    actions,
    mutations
}